module.exports = __webpack_public_path__ + "img/emotionFace.6e47c2b7.png";